import { Box } from "@mui/material";
import React, { PropsWithChildren } from "react";

import Loading from "../ui/Loading";
interface Props {
  isLoading: boolean;
}

const CalendarWrapper: React.FC<PropsWithChildren<Props>> = (props) => {
  const { isLoading, children } = props;
  return (
    <Box className="calendar-wrapper" position="relative">
      {children}
      {isLoading && <Loading />}
    </Box>
  );
};

export default CalendarWrapper;
